import { render, staticRenderFns } from "./watchList.vue?vue&type=template&id=7e072b7b&"
import script from "./watchList.vue?vue&type=script&lang=js&"
export * from "./watchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports